<template>
  <v-layout column>
    <activities-tab-navbar>
      <v-spacer />

      <list-edition-toolbar
        :buttons="toolbarButtons"
        horizontal-alignment="right"
        @add="$emit('addActivity')"
      />

      <toggle-buttons
        v-model="mode"
        :buttons="toggleButtons"
        style="margin: 6px 8px"
      />
    </activities-tab-navbar>

    <activities-table
      :object-uuid="objectUuid"
      :object-layer="objectLayer"
      @openActivity="$emit('openActivity', $event)"
      :mode="mode"
    />
  </v-layout>
</template>

<script>
import ActivitiesTabNavbar from "./ActivitiesTabNavbar";
import ActivitiesTable from "./ActivitiesTable";
import ListEditionToolbar from "@/components/Home/Forms/_Molecules/ListEditionToolbar";
import ToggleButtons from "@/components/_Atoms/AppToggleButtons";

export default {
  name: "ObjectFormActivitiesList",

  components: {
    ToggleButtons,
    ListEditionToolbar,
    ActivitiesTable,
    ActivitiesTabNavbar
  },

  props: {
    objectUuid: String,
    objectLayer: String,
    actionType: String
  },

  data() {
    return {
      mode: "all"
    };
  },

  computed: {
    toolbarButtons() {
      return [
        {
          id: "add",
          icon: "add_circle",
          tooltip: this.$i18n.t("AddActivity"),
          active: true
        }
      ];
    },

    toggleButtons() {
      return [
        { value: "all", text: this.$i18n.t("All") },
        { value: "history", text: this.$i18n.t("History") }
      ];
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Activities/ActivitiesList.vue